import { createApi } from '@reduxjs/toolkit/query/react';

import { HTTP_METHOD, USERS } from '../constants';
import * as endpoints from '../endpoints';
import {
  TransformedErrorResponseWithNotification,
  getBaseQuery,
} from '../generic';
import { AGREEMENT_CONTENT_PATH_BY_TYPE } from './agreements/agreementPolicy';
import {
  AgreementType,
  IAgreementAcceptancePayload,
  IAgreementAcceptanceResponse,
  IAgreementContentBlock,
} from './agreements/interfaces';
import { usersApi } from './users/usersApi';

export const agreementsApi = createApi({
  reducerPath: 'agreementsApi',
  tagTypes: [USERS.ME, USERS.ME_DETAILED],
  baseQuery: getBaseQuery(endpoints.Agreements.ROOT),
  keepUnusedDataFor: 3600,
  endpoints: (builder) => ({
    getAgreementContentApi: builder.query<
      IAgreementContentBlock[],
      AgreementType
    >({
      query(agreementType) {
        return {
          url: AGREEMENT_CONTENT_PATH_BY_TYPE[agreementType],
          method: HTTP_METHOD.GET,
        };
      },
      ...TransformedErrorResponseWithNotification(),
    }),
    postAgreementAcceptanceApi: builder.mutation<
      IAgreementAcceptanceResponse,
      IAgreementAcceptancePayload
    >({
      query(payload) {
        return {
          url: endpoints.Agreements.ACCEPTANCES,
          method: HTTP_METHOD.POST,
          body: payload,
        };
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(usersApi.util.invalidateTags([USERS.ME, USERS.ME_DETAILED]));
        } catch (error) {
          void error;
        }
      },
      invalidatesTags: [{ type: USERS.ME }, { type: USERS.ME_DETAILED }],
      ...TransformedErrorResponseWithNotification(),
    }),
  }),
});

export const {
  useGetAgreementContentApiQuery: useGetAgreementContent,
  usePostAgreementAcceptanceApiMutation: usePostAgreementAcceptance,
} = agreementsApi;
